export default __webpack_public_path__ + "static/media/demo_5.dda8beb2.png";